import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import lodash from "lodash";
import { URL } from "../url";
//component
import AllowScreen from "../layout/layout_allow_screen";
import { LoadingScreen } from "../../../component/loading";
// redux

import { useClaimToken } from "hook/useToken";
import { useLogged } from "hook/useLogged";

const PrivateRoute = (props) => {
  // -------------------------- VAR --------------------------
  const { permissions } = useClaimToken();
  const { logged } = useLogged();
  let location = useLocation();
  const element = props?.element;
  const require = props?.require;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------

  const diff =
    require?.length > 0 ? lodash.difference(require, permissions) : [];
  const allow = diff?.length === 0 ? true : false;

  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------

  if (logged === null) {
    return <LoadingScreen />;
  }
  if (logged === false) {
    return <Navigate to={URL.home} exact state={{ from: location }} replace />;
  }

  if (logged && !allow) {
    return <AllowScreen />;
  }
  return logged && allow ? (
    element
  ) : (
    <Navigate to={URL.home} exact state={{ from: location }} replace />
  );
};

export default PrivateRoute;
